const userLocale = typeof navigator !== 'undefined' ? navigator.language : 'en-US';
const numberFormatter = new Intl.NumberFormat(userLocale, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 5
});

const getOptionName = (price: string | number, parentName: string): string => {
  const priceNumber = Number(price);
  if (Number.isNaN(priceNumber)) {
    return `- ${parentName}`;
  }

  const roundedPrice = numberFormatter.format(parseFloat(priceNumber.toFixed(5)));
  return `${roundedPrice} ${parentName}`;
}

export default getOptionName;
